<ng-container *ngIf="bare; else gridLayout">
  <ng-container *ngTemplateOutlet="chart"></ng-container>
</ng-container>

<ng-template #gridLayout>
  <ion-grid [ngClass]="{ 'full-height': chartFullHeight }">
    <ion-row *ngIf="highChartsConfig">
      <ng-container *ngTemplateOutlet="chart"></ng-container>
    </ion-row>
  </ion-grid>
</ng-template>

<ng-template #chart>
  <highcharts-chart
    *ngIf="highChartsConfig"
    [Highcharts]="Highcharts"
    [options]="highChartsConfig"
    [ngStyle]="{ width: '100%', display: 'block' }"
  >
  </highcharts-chart>
</ng-template>
